import React from "react";

//importing styles
import {
  StyledSection,
  Wrapper,
  ErrorImage,
  ImageWrapper,
  ErrorText,
  HeaderText,
  ParaText,
  BulletText,
  LastText,
  MailText,
  StrongText,
} from "./styles";

import errorImage from "../../assets/images/imageError.png";

const ErrorPage = () => {
  return (
    <StyledSection>
      <Wrapper>
        <ErrorText>Privacy Policy</ErrorText>
        <ParaText>Last updated: 20 September 2022</ParaText>
        <ParaText>
          This Privacy Policy describes Our policies and procedures on the
          collection, use and disclosure of Your information when You use the
          Service and tells You about Your privacy rights and how the law
          protects You.
        </ParaText>
        <ParaText>
          We use Your Personal data to provide and improve the Service. By using
          the Service, You agree to the collection and use of information in
          accordance with this Privacy Policy.
        </ParaText>
        <HeaderText>Interpretation and Definitions</HeaderText>
        <HeaderText>Interpretation</HeaderText>
        <ParaText>
          The words of which the initial letter is capitalized have meanings
          defined under the following conditions. The following definitions
          shall have the same meaning regardless of whether they appear in
          singular or in plural.
        </ParaText>
        <HeaderText>Definitions</HeaderText>
        <ParaText>
          For the purposes of this Privacy Policy:
          <ul>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>Account</StrongText> means a unique account created
                for You to access our Service or parts of our Service.
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>Company</StrongText> (referred to as either
                &#x27;the Company&#x27;, &#x27;We&#x27;, &#x27;Us&#x27; or
                &#x27;Our&#x27; in this Agreement) refers to Kleio Innovation
                Labs Pvt Ltd, A-1/104, Harmony Complex, Boisar Tarapur Rd,
                Boisar West.
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>Cookies</StrongText> are small files that are placed
                on Your computer, mobile device or any other device by a
                website, containing the details of Your browsing history on that
                website among its many uses.
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>Country</StrongText> refers to: Maharashtra, India
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>Device</StrongText> means any device that can access
                the Service such as a computer, a cellphone or a digital tablet.
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>Personal Data</StrongText> is any information that
                relates to an identified or identifiable individual.
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>Service</StrongText> refers to the Website.
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>Service Provider</StrongText> means any natural or
                legal person who processes the data on behalf of the Company. It
                refers to third-party companies or individuals employed by the
                Company to facilitate the Service, to provide the Service on
                behalf of the Company, to perform services related to the
                Service or to assist the Company in analyzing how the Service is
                used.
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>Third-party Social Media Service</StrongText> refers
                to any website or any social network website through which a
                User can log in or create an account to use the Service.
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>Usage Data</StrongText> refers to data collected
                automatically, either generated by the use of the Service or
                from the Service infrastructure itself (for example, the
                duration of a page visit).
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>Website</StrongText> refers to Kleio Innovation Labs
                Pvt Ltd, accessible from
                <MailText
                  href="www.kleio.me"
                  rel="external nofollow noopener noreferrer"
                  target="blank">
                  www.kleio.me
                </MailText>
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>You</StrongText> means the individual accessing or
                using the Service, or the company, or other legal entity on
                behalf of which such individual is accessing or using the
                Service, as applicable.
              </ParaText>
            </li>
          </ul>
        </ParaText>
        <HeaderText>Collecting and Using Your Personal Data</HeaderText>
        <HeaderText>Types of Data Collected</HeaderText>
        <HeaderText>Personal Data</HeaderText>
        <ParaText>
          While using Our Service, We may ask You to provide Us with certain
          personally identifiable information that can be used to contact or
          identify You. Personally identifiable information may include, but is
          not limited to:
          <ul>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>Email address
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>First name and last name
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>Phone number
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>Address, State, Province,
                ZIP/Postal code, City
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>Usage Data
              </ParaText>
            </li>
          </ul>
        </ParaText>
        <HeaderText>Usage Data</HeaderText>
        <ParaText>
          Usage Data is collected automatically when using the Service.
        </ParaText>
        <ParaText>
          Usage Data may include information such as Your Device's Internet
          Protocol address (e.g. IP address), browser type, browser version, the
          pages of our Service that You visit, the time and date of Your visit,
          the time spent on those pages, unique device identifiers and other
          diagnostic data.
        </ParaText>
        <ParaText>
          When You access the Service by or through a mobile device, We may
          collect certain information automatically, including, but not limited
          to, the type of mobile device You use, Your mobile device unique ID,
          the IP address of Your mobile device, Your mobile operating system,
          the type of mobile Internet browser You use, unique device identifiers
          and other diagnostic data.
        </ParaText>
        <ParaText>
          We may also collect information that Your browser sends whenever You
          visit our Service or when You access the Service by or through a
          mobile device.
        </ParaText>
        <HeaderText>Tracking Technologies and Cookies</HeaderText>
        <ParaText>
          We use Cookies and similar tracking technologies to track the activity
          on Our Service and store certain information. Tracking technologies
          used are beacons, tags, and scripts to collect and track information
          and to improve and analyze Our Service. The technologies We use may
          include:
          <ul>
            <li>
              <BulletText>{"\u2B24"}</BulletText>
              <StrongText>Cookies or Browser Cookies.</StrongText> A cookie is a
              small file placed on Your Device. You can instruct Your browser to
              refuse all Cookies or to indicate when a Cookie is being sent.
              However, if You do not accept Cookies, You may not be able to use
              some parts of our Service. Unless you have adjusted Your browser
              setting so that it will refuse Cookies, our Service may use
              Cookies.
            </li>

            <li>
              <BulletText>{"\u2B24"}</BulletText>
              <StrongText>Web Beacons.</StrongText> Certain sections of our
              Service and our emails may contain small electronic files known as
              web beacons (also referred to as clear gifs, pixel tags, and
              single-pixel gifs) that permit the Company, for example, to count
              users who have visited those pages or opened an email and for
              other related website statistics (for example, recording the
              popularity of a certain section and verifying system and server
              integrity).
            </li>
          </ul>
        </ParaText>
        <ParaText>
          Cookies can be 'Persistent' or 'Session' Cookies. Persistent Cookies
          remain on Your personal computer or mobile device when You go offline,
          while Session Cookies are deleted as soon as You close Your web
          browser.
        </ParaText>
        <ParaText>
          We use both Session and Persistent Cookies for the purposes set out
          below:
        </ParaText>
        <ParaText>
          <ul>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>Necessary / Essential Cookies</StrongText>
              </ParaText>
              <ParaText>Type: Session Cookies</ParaText>
              <ParaText>Administered by: Us</ParaText>
              <ParaText>
                Purpose: These Cookies are essential to provide You with
                services available through the Website and to enable You to use
                some of its features. They help to authenticate users and
                prevent fraudulent use of user accounts. Without these Cookies,
                the services that You have asked for cannot be provided, and We
                only use these Cookies to provide You with those services.
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>
                  Cookies Policy / Notice Acceptance Cookies
                </StrongText>
              </ParaText>
              <ParaText>Type: Persistent Cookies</ParaText>
              <ParaText>Administered by: Us</ParaText>
              <ParaText>
                Purpose: These Cookies identify if users have accepted the use
                of cookies on the Website.
              </ParaText>
            </li>
            <li>
              <ParaText>
                <BulletText>{"\u2B24"}</BulletText>
                <StrongText>Functionality Cookies</StrongText>
              </ParaText>
              <ParaText>Type: Persistent Cookies</ParaText>
              <ParaText>Administered by: Us</ParaText>
              <ParaText>
                Purpose: These Cookies allow us to remember choices You make
                when You use the Website, such as remembering your login details
                or language preference. The purpose of these Cookies is to
                provide You with a more personal experience and to avoid You
                having to re-enter your preferences every time You use the
                Website.
              </ParaText>
            </li>
          </ul>
        </ParaText>
        <ParaText>
          For more information about the cookies we use and your choices
          regarding cookies, please visit our Cookies Policy or the Cookies
          section of our Privacy Policy.
        </ParaText>
        <HeaderText>Use of Your Personal Data</HeaderText>
        <ParaText>
          The Company may use Personal Data for the following purposes:
        </ParaText>
        <ul>
          <li>
            <ParaText>
              <BulletText>{"\u2B24"}</BulletText>
              <StrongText>To provide and maintain our Service</StrongText>,
              including to monitor the usage of our Service.
            </ParaText>
          </li>
          <li>
            <ParaText>
              <BulletText>{"\u2B24"}</BulletText>
              <StrongText>To manage Your Account:</StrongText> to manage Your
              registration as a user of the Service. The Personal Data You
              provide can give You access to different functionalities of the
              Service that are available to You as a registered user.
            </ParaText>
          </li>
          <li>
            <ParaText>
              <BulletText>{"\u2B24"}</BulletText>
              <StrongText>For the performance of a contract:</StrongText> the
              development, compliance and undertaking of the purchase contract
              for the products, items or services You have purchased or of any
              other contract with Us through the Service.
            </ParaText>
          </li>
          <li>
            <ParaText>
              <BulletText>{"\u2B24"}</BulletText>
              <StrongText>To contact You:</StrongText> To contact You by email,
              telephone calls, SMS, or other equivalent forms of electronic
              communication, such as a mobile application&#x27;s push
              notifications regarding updates or informative communications
              related to the functionalities, products or contracted services,
              including the security updates, when necessary or reasonable for
              their implementation.
            </ParaText>
          </li>
          <li>
            <ParaText>
              <BulletText>{"\u2B24"}</BulletText>
              <StrongText>To provide You</StrongText> with news, special offers
              and general information about other goods, services and events
              which we offer that are similar to those that you have already
              purchased or enquired about unless You have opted not to receive
              such information.
            </ParaText>
          </li>
          <li>
            <ParaText>
              <BulletText>{"\u2B24"}</BulletText>
              <StrongText>To manage Your requests:</StrongText> To attend and
              manage Your requests to Us.
            </ParaText>
          </li>
          <li>
            <ParaText>
              <BulletText>{"\u2B24"}</BulletText>
              <StrongText>For business transfers:</StrongText> We may use Your
              information to evaluate or conduct a merger, divestiture,
              restructuring, reorganization, dissolution, or other sale or
              transfer of some or all of Our assets, whether as a going concern
              or as part of bankruptcy, liquidation, or similar proceeding, in
              which Personal Data held by Us about our Service users is among
              the assets transferred.
            </ParaText>
          </li>
          <li>
            <ParaText>
              <BulletText>{"\u2B24"}</BulletText>
              <StrongText>For other purposes</StrongText>: We may use Your
              information for other purposes, such as data analysis, identifying
              usage trends, determining the effectiveness of our promotional
              campaigns and to evaluate and improve our Service, products,
              services, marketing and your experience.
            </ParaText>
          </li>
        </ul>
        <ParaText>
          We may share Your personal information in the following situations:
        </ParaText>
        <ul>
          <li>
            <ParaText>
            <BulletText>{"\u2B24"}</BulletText>
            <StrongText>With Service Providers:</StrongText> We may share Your
            personal information with Service Providers to monitor and analyze
            the use of our Service, to contact You.
            </ParaText>
          </li>
          <li>
            <ParaText>
            <BulletText>{"\u2B24"}</BulletText>
            <StrongText>For business transfers:</StrongText> We may share or
            transfer Your personal information in connection with, or during
            negotiations of, any merger, sale of Company assets, financing, or
            acquisition of all or a portion of Our business to another company.
            </ParaText>
          </li>
          <li>
          <ParaText>
            <BulletText>{"\u2B24"}</BulletText>
            <StrongText>With Affiliates:</StrongText> We may share Your
            information with Our affiliates, in which case we will require those
            affiliates to honor this Privacy Policy. Affiliates include Our
            parent company and any other subsidiaries, joint venture partners or
            other companies that We control or that are under common control
            with Us.
            </ParaText>
          </li>
          <li>
          <ParaText>
            <BulletText>{"\u2B24"}</BulletText>
            <StrongText>With business partners:</StrongText> We may share Your
            information with Our business partners to offer You certain
            products, services or promotions.
            </ParaText>
          </li>
          <li>
          <ParaText>
            <BulletText>{"\u2B24"}</BulletText>
            <StrongText>With other users:</StrongText> when You share personal
            information or otherwise interact in the public areas with other
            users, such information may be viewed by all users and may be
            publicly distributed outside. If You interact with other users or
            register through a Third-Party Social Media Service, Your contacts
            on the Third-Party Social Media Service may see Your name, profile,
            pictures and description of Your activity. Similarly, other users
            will be able to view descriptions of Your activity, communicate with
            You and view Your profile.
            </ParaText>
          </li>
          <li>
          <ParaText>
            <BulletText>{"\u2B24"}</BulletText>
            <StrongText>With Your consent</StrongText>: We may disclose Your
            personal information for any other purpose with Your consent.
            </ParaText>
          </li>
        </ul>
        <HeaderText>Retention of Your Personal Data</HeaderText>
        <ParaText>
          The Company will retain Your Personal Data only for as long as is
          necessary for the purposes set out in this Privacy Policy. We will
          retain and use Your Personal Data to the extent necessary to comply
          with our legal obligations (for example, if we are required to retain
          your data to comply with applicable laws), resolve disputes, and
          enforce our legal agreements and policies.
        </ParaText>
        <ParaText>
          The Company will also retain Usage Data for internal analysis
          purposes. Usage Data is generally retained for a shorter period of
          time, except when this data is used to strengthen the security or to
          improve the functionality of Our Service, or We are legally obligated
          to retain this data for longer time periods.
        </ParaText>
        <HeaderText>Transfer of Your Personal Data</HeaderText>
        <ParaText>
          Your information, including Personal Data, is processed at the
          Company&#x27;s operating offices and in any other places where the
          parties involved in the processing are located. It means that this
          information may be transferred to — and maintained on — computers
          located outside of Your state, province, country or other governmental
          jurisdiction where the data protection laws may differ than those from
          Your jurisdiction.
        </ParaText>
        <ParaText>
          Your consent to this Privacy Policy followed by Your submission of
          such information represents Your agreement to that transfer.
        </ParaText>
        <ParaText>
          The Company will take all steps reasonably necessary to ensure that
          Your data is treated securely and in accordance with this Privacy
          Policy and no transfer of Your Personal Data will take place to an
          organization or a country unless there are adequate controls in place
          including the security of Your data and other personal information.
        </ParaText>
        <h2 class="subHeadPvcH2">Disclosure of Your Personal Data</h2>
        <HeaderText class="subHeadPvc">Business Transactions</HeaderText>
        <ParaText>
          If the Company is involved in a merger, acquisition or asset sale,
          Your Personal Data may be transferred. We will provide notice before
          Your Personal Data is transferred and becomes subject to a different
          Privacy Policy.
        </ParaText>
        <HeaderText>Law enforcement</HeaderText>
        <ParaText>
          Under certain circumstances, the Company may be required to disclose
          Your Personal Data if required to do so by law or in response to valid
          requests by public authorities (e.g. a court or a government agency).
        </ParaText>
        <HeaderText>Other legal requirements</HeaderText>
        <ParaText>
          The Company may disclose Your Personal Data in the good faith belief
          that such action is necessary to:
        </ParaText>
        <ul>
          <li>
          <ParaText>
            <BulletText>{"\u2B24"}</BulletText>Comply with a legal obligation
            </ParaText>
          </li>
          <li>
          <ParaText>
            <BulletText>{"\u2B24"}</BulletText>Protect and defend the rights or
            property of the Company
            </ParaText>
          </li>
          <li>
          <ParaText>
            <BulletText>{"\u2B24"}</BulletText>
            Prevent or investigate possible wrongdoing in connection with the
            Service
            </ParaText>
          </li>
          <li>
          <ParaText>
            <BulletText>{"\u2B24"}</BulletText>
            Protect the personal safety of Users of the Service or the public
            </ParaText>
          </li>
          <li>
          <ParaText>
            <BulletText>{"\u2B24"}</BulletText>Protect against legal liability
            </ParaText>
          </li>
        </ul>
        <HeaderText>Security of Your Personal Data</HeaderText>
        <ParaText>
          The security of Your Personal Data is important to Us, but remember
          that no method of transmission over the Internet, or method of
          electronic storage is 100% secure. While We strive to use commercially
          acceptable means to protect Your Personal Data, We cannot guarantee
          its absolute security.
        </ParaText>
        <HeaderText>Children&#x27;s Privacy</HeaderText>
        <ParaText>
          Our Service does not address anyone under the age of 13. We do not
          knowingly collect personally identifiable information from anyone
          under the age of 13. If You are a parent or guardian and You are aware
          that Your child has provided Us with Personal Data, please contact Us.
          If We become aware that We have collected Personal Data from anyone
          under the age of 13 without verification of parental consent, We take
          steps to remove that information from Our servers.
        </ParaText>
        <ParaText>
          If We need to rely on consent as a legal basis for processing Your
          information and Your country requires consent from a parent, We may
          require Your parent&#x27;s consent before We collect and use that
          information.
        </ParaText>
        <HeaderText>Links to Other Websites</HeaderText>
        <ParaText>
          Our Service may contain links to other websites that are not operated
          by Us. If You click on a third party link, You will be directed to
          that third party&#x27;s site. We strongly advise You to review the
          Privacy Policy of every site You visit.
        </ParaText>
        <ParaText>
          We have no control over and assume no responsibility for the content,
          privacy policies or practices of any third party sites or services.
        </ParaText>
        <HeaderText>Changes to this Privacy Policy</HeaderText>
        <ParaText>
          We may update Our Privacy Policy from time to time. We will notify You
          of any changes by posting the new Privacy Policy on this page.
        </ParaText>
        <ParaText>
          We will let You know via email and/or a prominent notice on Our
          Service, prior to the change becoming effective and update the
          &#x27;Last updated&#x27; date at the top of this Privacy Policy.
        </ParaText>
        <ParaText>
          You are advised to review this Privacy Policy periodically for any
          changes. Changes to this Privacy Policy are effective when they are
          posted on this page.
        </ParaText>

        <HeaderText>Contact Details</HeaderText>
        <LastText>
          If you have any questions about this Privacy Policy, You can contact
          us:
          <MailText href="mailto:contact@kleio.me">contact@kleio.me</MailText>
        </LastText>
      </Wrapper>
    </StyledSection>
  );
};

export default ErrorPage;
